import React, {PropTypes} from 'react'
import styles from './ComponentPageDom.scss'
import cs from 'classnames'

const ComponentPageDom = ({ title, subtitle, children, noHeader, extraClassName, extraClassNameMainSubDiv,
	usesBackButton=false, backButtonOnClick=null, backButtonLabel="back"}) => {
	const showHeader = !noHeader
	return (
		<div className={cs(styles.pageModule, (extraClassName ? extraClassName : {}))}>
			<div className={cs(styles.mainSubDiv, (extraClassNameMainSubDiv ? extraClassNameMainSubDiv : {}))}>
				{showHeader &&
					<div className={`${styles.mainTitleDiv} bottom-border`}>
						<div className={styles.mainTitleContainer}>
							<h2>{title}</h2>
							<h3>{subtitle}</h3>
						</div>
						{usesBackButton &&
							<div className={styles.moduleControls}>
								<div className={styles.buttonOrganizer}>
									<button
										className={styles.backToList}
										onClick={() => {
											if (typeof backButtonOnClick == "function") {
												return backButtonOnClick()
											}

											return
										}}
									>
										{"← " + backButtonLabel}
									</button>
								</div>
							</div>
						}
					</div>
				}
				{children}
			</div>
		</div>
	)
}
ComponentPageDom.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	children: React.PropTypes.node,
	noHeader: React.PropTypes.bool,
}
export default ComponentPageDom



// WEBPACK FOOTER //
// ./elements/ComponentPageDom.jsx